import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ToolIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M16.56 3.03a5 5 0 0 0-5.12 7.03 1 1 0 0 1-.2 1.12l-6.91 6.9a1.12 1.12 0 0 0 1.58 1.6l6.91-6.92a1 1 0 0 1 1.12-.2 5 5 0 0 0 7.03-5.12l-2.57 2.57a2 2 0 0 1-2.8 0L13.98 8.4a2 2 0 0 1 0-2.8l2.57-2.57ZM14.74 1.1a7 7 0 0 1 4.14.5 1 1 0 0 1 .3 1.63L15.4 7 17 8.59l3.76-3.77a1 1 0 0 1 1.62.3 7 7 0 0 1-8.6 9.52l-6.45 6.45a3.12 3.12 0 0 1-4.42-4.42l6.45-6.44a7 7 0 0 1 5.38-9.12Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default ToolIcon;
